export default "__VITE_ASSET__D4V04JW6__"